<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    {{$t('news.template.opinion.generatedByVotingMember.p1')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.opinion.generatedByVotingMember.p2')}}
    "<router-link
    :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}">
    {{news.textParams[3]}}</router-link>"
    {{$t('news.template.opinion.generatedByVotingMember.p3')}}
    "<router-link
    :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}">
    {{news.textParams[4]}}</router-link>".
    {{$t('news.template.opinion.generatedByVotingMember.p4')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.opinion.generatedByVotingMember.p5')}}
  </div>
</template>
